import { useState } from 'react';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { useClientFilterParams } from '@/components/app/archive/helpers/hooks';

import {
  DATA_CY_ALL_QUESTIONS,
  DATA_CY_BUYER_QUESTIONS,
  DATA_CY_QUESTIONS_FILTER,
} from '@/constant/cypress';
import { pageLevelLocalization } from '@/constant/localization';
const { product: productLocalization } = pageLevelLocalization;

export default function Filter() {
  const { updateParams } = useClientFilterParams(); //TODO: change to useFilterParams
  const [activeFilter, setActiveFilter] = useState<string>('');
  const handleFilterClick = (key: string, value: string) => {
    updateParams(key, value);
    //reset to page 1
    updateParams('page', 1);
    setActiveFilter(value);
  };
  return (
    <Container data-cy={DATA_CY_QUESTIONS_FILTER} center className='justify-start gap-2 py-7'>
      <Button
        data-cy={DATA_CY_ALL_QUESTIONS}
        className={
          activeFilter === ''
            ? 'h-[36px] bg-[#FEA0001A] text-[#FF9606]'
            : 'h-[36px] bg-[#F7F8F9] text-[#878F9B]'
        }
        onClick={() => handleFilterClick('badge', '')}
      >
        {productLocalization.allQuestions}
      </Button>
      <Button
        data-cy={DATA_CY_BUYER_QUESTIONS}
        className={
          activeFilter === 'customer'
            ? 'h-[36px] bg-[#FEA0001A] text-[#FF9606]'
            : 'h-[36px] bg-[#F7F8F9] text-[#878F9B]'
        }
        onClick={() => handleFilterClick('badge', 'customer')}
      >
        {productLocalization.justBuyersComments}
      </Button>
    </Container>
  );
}
